<template>
  <div>
    <v-card-text>
      アカウント情報
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="text--primary">
      <span>メールアドレス</span>
      <v-spacer></v-spacer>
      <span>{{ this.teacher.email }}</span>
    </v-card-text>
    <v-container>
      <v-row justify="end">
        <v-card-actions>
          <v-btn
            outlined
            class="ma-2"
            @click="firstDialog=true">
            アカウントを削除する
          </v-btn>
        </v-card-actions>
      </v-row>
    </v-container>

    <v-dialog
      v-model="firstDialog"
      max-width="500"
      persistent>
      <v-card>
        <v-card-title>
          パスワードを入力してください。
        </v-card-title>
        <v-text-field
          v-model="password"
          prepend-icon="lock"
          name="password"
          label="パスワード"
          type="password"
          v-validate="'required|min:6'"
          data-vv-name="password"
          data-vv-as="パスワード"
          required
          :error-messages="errors.collect('password')"
        />
        <v-container>
          アカウントを削除しますか？
          <v-row justify="end">
            <v-card-text>
              {{ this.errorMessage }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                class="ma-2"
                @click="judge()">
                はい
              </v-btn>
              <v-btn
                outlined
                class="ma-2"
                @click="firstDialog=false">
                いいえ
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="secondDialog"
      max-width="500"
      persistent>
      <v-card>
        <v-container>
          授業予定が存在します。<br>
          アカウントを消すことはできません。
          <v-row justify="end">
            <v-card-actions>
              <v-btn
                outlined
                class="ma-2"
                @click="secondDialog=false">
                OK
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth } from '@/auth/client/firebase'
import { firestore } from '@/repository/client/firestore.js'
import { TeacherRepository } from '@/repository/TeacherRepository.js'
import { AuthService } from "@/service/auth/auth"

export default {
  name: 'TeacherAccount',
  data() {
    return {
      teacher: this.$store.getters.teacher,
      firstDialog: false,
      secondDialog: false,
      password: null,
      errorMessage: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  methods: {
    async deleteAccount() {
      const result = await this.$validator.validateAll()
      if (result) {
        try {
          const teacherRepo = new TeacherRepository(firestore)
          await teacherRepo.delete(this.teacher)
          await this.authService.deleteUser(this.teacher.email, this.password)
        } catch(e) {
          this.errorMessage = e.message
        }
      }
    },
    judge() {
      if (this.lessons.length === 0) {
        this.deleteAccount()
      } else {
        this.firstDialog = false
        this.secondDialog = true
      }
    }
  },
  created() {
    this.authService = new AuthService(auth, firestore)
    this.lessons = this.teacher.lessons.get()
  }
}
</script>